<termo-header />
@for (location of enrichedLocations(); track location.id) {
  <termo-map-location [location]="location"
    [loading]="isLoading()"
    [selected]="selectedLocation()?.id === location.id"
    (selectLocation)="onLocationSelect(location)"
   />
}
